import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class JtsnxAlertService {
  serverUrl = '';
  constructor(private http: HttpClient) {}

  getAlertList() {
    return this.http.get(this.serverUrl + 'JTSnxBllSvc/api/AlertCommon/GetAlertList');
  }

  getAdmitCaseWorker(juvenileID) {
    return this.http.get(this.serverUrl + 'JTSnxBllSvc/api/AlertsMain/GetAdmitCaseWorker?juvenileId=' + juvenileID);
  }

  getCSECLevelStatus(juvenileID) {
    return this.http.get(this.serverUrl + 'JTSnxBllSvc/api/AlertCommon/GetCSECLevelStatus?juvenileId=' + juvenileID);
  }

  getAlertsInfo(juvenileID) {
    return this.http.get(this.serverUrl + 'JTSnxBllSvc/api/AlertsMain/GetAlertsInfo?juvenileId=' + juvenileID);
  }

  insertAlert(model) {
    return this.http.post(this.serverUrl + 'JTSnxBllSvc/api/AlertsMain/InsertAlert', model);
  }

  dToD(dateString) {
    if (typeof dateString === 'string') {
      const a = dateString.split(/[^0-9]/);
      return new Date(+a[0], +a[1] - 1, +a[2], +a[3], +a[4], +a[5]);
    } else {
      if (dateString === null) {
        return null;
      } else {
        return new Date(dateString);
      }
    }
  }
}
